import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { NameSurnameFunction } from './name-surname-function';

const regex = /^[a-zA-Z\u00C0-\u024F '\-]{3,}$/;

export const NameValidator: ValidatorFn = (control: AbstractControl): ValidationErrors => NameSurnameFunction(regex, control);
